import api from './api';

export interface DiscussReview {
  id: string;
  mode: 'solo' | 'together';
  jurisdiction: string;
  model: string;
  promptVersion: string;
  createdAt: number;
  endedAt: number;
  expiresAt: number;
  ended: 'by_user' | 'expired' | 'inactive';
  participants: number;
  stats: {
    humanMessages: number; aiTurns: number; aiSpoke: number; aiSilent: number;
    cards: number; safetyFlags: number; refusals: number; thumbsUp: number; thumbsDown: number;
  };
  usage: {
    calls: number; inputTokens: number; outputTokens: number;
    cacheReadTokens: number; cacheWriteTokens: number; costUsd: number;
  };
  endFeedback: { helped: 'yes' | 'somewhat' | 'no' | null }[];
}
export interface DiscussTranscript extends DiscussReview {
  transcript: { at: number; who: string; text: string; kind: 'human' | 'discuss' | 'card' | 'event' | 'safety' }[];
}
export interface DiscussReviewPage { reviews: DiscussReview[]; nextCursor: number | null }
export interface DiscussStats { today: string; costUsd: number; rooms: number; dailyBudgetUsd: number; fakeAi: boolean }

export async function getDiscussReviews(before?: number, signal?: AbortSignal): Promise<DiscussReviewPage> {
  return (await api.get('/api/discuss/reviews', { params: { limit: 50, before }, signal })).data.data;
}
export async function getDiscussReview(id: string, signal?: AbortSignal): Promise<DiscussTranscript> {
  return (await api.get(`/api/discuss/reviews/${encodeURIComponent(id)}`, { signal })).data.data;
}
export async function getDiscussStats(signal?: AbortSignal): Promise<DiscussStats> {
  return (await api.get('/api/discuss/stats', { signal })).data.data;
}

export interface DiscussInterest { email: string; source: 'landing' | 'ended'; site: 'in' | 'uk'; createdAt: number }
export interface DiscussFunnel { view: number; start: number; room: number; interest: number }
export interface DiscussExperiment { experiment: string; since: string; variants: { variant: string; sites: { in: DiscussFunnel; uk: DiscussFunnel } }[] }

export async function getDiscussInterest(signal?: AbortSignal): Promise<DiscussInterest[]> {
  return (await api.get('/api/discuss/interest', { signal })).data.data.interest;
}
export async function removeDiscussInterest(email: string): Promise<boolean> {
  return (await api.delete(`/api/discuss/interest/${encodeURIComponent(email)}`)).data.data.removed;
}
export async function getDiscussExperiment(id: string, signal?: AbortSignal): Promise<DiscussExperiment> {
  return (await api.get(`/api/discuss/experiments/${encodeURIComponent(id)}`, { signal })).data.data;
}
